import {
  Dashboard,
  MainAccount,
  ManageMainAccount,
  IncomingTransaction,
  OutgoingTransaction,
  ViewTransaction,
  ViewUserTransaction,
  withType,
  History,
  Profile,
  ChangePassword,
  RegistrationStep,
  ReInstall,
  TotalAccount,
  AccountDetail,
  MobileUser,
  MobileUserSearch,
  DesktopUser,
  WebUser,
  KeyRecoveryRequests,
  CustomerInfo,
  MobileCustomerInfo,
  WaitingForApproveMobile,
  WaitingForApproveDesktop,
  WaitingForApproveWeb,
  DesktopLimit,
  MobileLimit,
  WebLimit,
  AddLimit,
  EditLimit,
  TermsAndConditionsMobile,
  TermsAndConditionsDesktop,
  ManageAuthorizers,
  BankInfo,
  ChangePhoneRequests,
  RecoveryRequests,
  RecoveryDetail,
  Roles,
  Permissions,
  Endpoints,
  Users,
  Notifications,
  BlankPage,
  Download,
  AuditLogs,
} from "./views";
import { TermsAndConditionsWeb } from "./views/TermsAndConditions";

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config

// Page that include in Menu, Header, Footer
const routes = [
  // Keyholder registration
  {
    path: "/keyholder/registration",
    name: "Register Account",
    component: RegistrationStep,
  },
  {
    path: "/keyholder/re-install",
    name: "Re-Installation",
    component: ReInstall,
  },
  {
    path: "/blank-page",
    name: "Blank page",
    isDefault: true,
    component: BlankPage,
  },

  // Dashboard
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/main_account",
    name: "Main Account",
    component: MainAccount,
  },
  {
    path: "/manage_main_account",
    name: "Manage Main Account",
    component: ManageMainAccount,
  },
  {
    path: "/total_account",
    name: "Total Account",
    component: TotalAccount,
  },
  {
    path: "/account_detail/:id",
    name: "Account Detail",
    component: AccountDetail,
    parents: ["/total_account"],
  },
  {
    path: "/incoming_transactions",
    name: "Incoming Transactions",
    component: IncomingTransaction,
  },
  {
    path: "/outgoing_transactions",
    name: "Outgoing Transactions",
    component: OutgoingTransaction,
  },
  /*
   manual set route for account detail:
   this use to keep user not to confused.
  */
  {
    path: "/view_transaction/:id",
    name: "Account Detail",
    exact: true,
    component: AccountDetail,
    parents: ["/total_account"],
  },
  {
    path: "/view_incoming_transaction/:accountId/:id",
    name: "View Incoming Transaction",
    component: withType("incoming")(ViewUserTransaction),
    parents: ["/dashboard", "/incoming_transactions"],
  },
  {
    path: "/view_outgoing_transaction/:accountId/:id",
    name: "View Outgoing Transaction",
    component: withType("outgoing")(ViewUserTransaction),
    parents: ["/dashboard", "/outgoing_transactions"],
  },
  {
    path: "/view_audit_transaction/:accountId/:id",
    name: "View Auditor History Transaction",
    component: withType("history")(ViewUserTransaction),
    parents: ["/auditor-history"],
  },
  {
    path: "/view_history_transaction/:accountId/:id",
    name: "View History Transaction",
    component: withType("history")(ViewUserTransaction),
    parents: ["/history"],
  },
  {
    path: "/view_transaction/:accountId/:id",
    name: "View Transaction",
    component: ViewTransaction,
    parents: ["/total_account"],
  },
  {
    path: "/history",
    name: "History",
    component: History,
  },
  {
    path: "/download",
    name: "Download",
    component: Download,
  },
  {
    path: "/auditor-history",
    name: "Auditor History",
    component: withType("auditor")(History),
  },
  {
    path: "/settings",
    exact: true,
    name: "Settings",
    component: Profile,
    isDefault: true,
  },
  {
    path: "/settings/profile",
    name: "Profile",
    component: Profile,
    isDefault: true,
  },
  {
    path: "/settings/change_password",
    name: "Change Password",
    component: ChangePassword,
    isDefault: true,
  },
  {
    path: "/customer_kyc_info/:id",
    name: "Customer Information",
    component: CustomerInfo,
    parents: ["/waiting_for_approval"],
  },
  {
    path: "/kyc_info/:id",
    name: "Customer KYC Information",
    component: MobileCustomerInfo,
    parents: [
      "/desktop-users",
      "/mobile-user-search",
      "/mobile-users",
      "/web-users",
      "/waiting_for_approval",
    ],
  },
  {
    path: "/auditor_kyc_info/:id",
    name: "Customer KYC Information",
    component: withType("auditor")(MobileCustomerInfo),
    parents: ["/mobile-user-search", "/auditor-users"],
  },
  {
    path: "/change-phone-requests-admin",
    name: "Change Primary Contact Requests Manager",
    component: withType("admin")(ChangePhoneRequests),
  },
  // Authorizer
  {
    path: "/change-phone-requests",
    name: "Change Primary Contact Requests",
    component: withType("authorizer")(ChangePhoneRequests),
  },
  {
    path: "/recovery-requests",
    name: "Recovery requests",
    component: RecoveryRequests,
  },
  {
    path: "/recovery-requests-info/:id",
    name: "View key recovery request information",
    parents: ["/recovery-requests"],
    component: RecoveryDetail,
  },
  // Admin
  {
    path: "/waiting_for_approval",
    exact: true,
    name: "Waiting for Approval",
    component: WaitingForApproveMobile,
  },
  {
    path: "/waiting_for_approval/mobile",
    name: "Mobile requests",
    component: WaitingForApproveMobile,
  },
  {
    path: "/waiting_for_approval/desktop",
    name: "Desktop requests",
    component: WaitingForApproveDesktop,
  },
  {
    path: "/waiting_for_approval/web",
    name: "Web requests",
    component: WaitingForApproveWeb,
  },
  {
    path: "/mobile-users",
    name: "Mobile Users",
    component: MobileUser,
  },
  {
    path: "/auditor-users",
    name: "Auditor Users",
    component: withType("auditor")(MobileUser),
  },
  {
    path: "/mobile-user-search",
    name: "Search mobile user",
    component: MobileUserSearch,
  },
  {
    path: "/desktop-users",
    name: "Desktop Users",
    component: DesktopUser,
  },
  {
    path: "/web-users",
    name: "Web Users",
    component: WebUser,
  },
  {
    path: "/key_recovery_requests",
    name: "Key recovery requests list",
    component: KeyRecoveryRequests,
  },
  {
    path: "/key_recovery_requests_info/:id",
    name: "View key recovery request information",
    parents: ["/key_recovery_requests"],
    component: RecoveryDetail,
  },
  {
    path: "/manage_authorizers/:accountId",
    name: "Manage authorizers",
    component: ManageAuthorizers,
    parents: ["/waiting_for_approval", "/desktop-users", "/mobile-user-search"],
  },
  {
    path: "/view_bank_info",
    name: "Bank Contact Information",
    component: BankInfo,
  },
  // KYCLimitAmount
  {
    path: "/kyc-limit-amount",
    exact: true,
    name: "User KYC Limit Amount",
    component: MobileLimit,
  },
  {
    path: "/kyc-limit-amount/mobile-limit",
    name: "Mobile Limits",
    component: MobileLimit,
  },
  {
    path: "/kyc-limit-amount/desktop-limit",
    name: "Desktop Limits",
    component: DesktopLimit,
  },
  {
    path: "/kyc-limit-amount/web-limit",
    name: "Web Limits",
    component: WebLimit,
  },
  {
    path: "/kyc-limit-edit/:limitId",
    name: "Edit limit",
    component: EditLimit,
    parents: ["/kyc-limit-amount"],
  },
  {
    path: "/kyc-limit-add",
    name: "Add limit",
    component: AddLimit,
  },
  {
    path: "/terms_and_conditions/mobile",
    name: "Terms and Conditions",
    component: TermsAndConditionsMobile,
  },
  {
    path: "/terms_and_conditions/desktop",
    name: "Terms and Conditions",
    component: TermsAndConditionsDesktop,
  },
  {
    path: "/terms_and_conditions/web",
    name: "Terms and Conditions",
    component: TermsAndConditionsWeb,
  },
  // Roles
  {
    path: "/roles",
    exact: true,
    name: "Roles",
    component: Roles,
  },
  {
    path: "/endpoints",
    exact: true,
    name: "Endpoints",
    component: Endpoints,
  },
  {
    path: "/pages",
    exact: true,
    name: "Pages",
    component: Permissions,
  },
  {
    path: "/users",
    exact: true,
    name: "Users",
    component: Users,
  },
  {
    path: "/notifications",
    exact: true,
    name: "Notifications",
    component: Notifications,
  },
  {
    path: "/audit-logs",
    exact: true,
    name: "Audit Logs",
    component: AuditLogs,
  },
];

export default routes;
